import { MessagingSlice } from './types';

export const initialState: MessagingSlice = {
    conversations: {
        forEventsAfterTimestamp: new Date(1).toISOString(),
        forEventsUntilTimestamp: new Date(1).toISOString(),
        latestEventTimestamp: new Date(1).toISOString(),
        earliestEventTimestamp: new Date(1).toISOString(),
        conversationStatuses: [],
    },
    messages: {},
    pendingMessages: {},
    failedToSendMessages: {},
    mostRecentMessages: {},
    hasInitialisedMessages: [],
    isLoadingConversations: true,
    isInsertingNewConversation: false,
    didErrorWhileLoadingConversations: false,
    didErrorWhileLoadingMessages: [], // by conversation ID
    haveUnreadMessages: false,
};
